export default __webpack_public_path__ + "static/media/Trustage.470d0492.svg";